/* i40 product verifier v2: individual-value parsing and separator-insensitive matching. */
(function () {
  'use strict';

  var MATCH_MESSAGE = 'Match found! This part number appears in our cross-reference list. Please confirm final fitment using your engine serial number or VIN.';
  var NO_MATCH_MESSAGE = 'No exact cross-reference match was found. Submit the fitment form and our team can verify your application.';

  function normalizePartNumber(value) {
    return String(value == null ? '' : value)
      .trim()
      .toLowerCase()
      .replace(/[\s\-\/,]+/g, '');
  }

  function splitPartNumberText(value) {
    return String(value == null ? '' : value)
      .split(',')
      .map(function (partNumber) { return partNumber.trim(); })
      .filter(function (partNumber) { return partNumber.length > 0; });
  }

  function parseCrossReferences(source) {
    var decoded = source == null ? '' : source;
    var attempts = 0;

    while (typeof decoded === 'string' && attempts < 3) {
      var text = decoded.trim();
      if (!text) return [];
      try {
        decoded = JSON.parse(text);
        attempts += 1;
      } catch (error) {
        decoded = text;
        break;
      }
    }

    if (Array.isArray(decoded)) {
      return decoded.reduce(function (partNumbers, value) {
        return partNumbers.concat(splitPartNumberText(value));
      }, []);
    }
    return splitPartNumberText(decoded);
  }

  function setupVerifier(host) {
    if (host.dataset.i40Ready === 'true') return;
    var form = host.querySelector('[data-i40-verifier-form]');
    var data = host.querySelector('[data-i40-crossrefs]');
    var result = host.querySelector('[data-i40-verifier-result]');
    var input = form && form.querySelector('input[name="part_number"]');
    if (!form || !data || !result || !input) return;

    var values = parseCrossReferences(data.textContent);

    var exactMatches = new Set(
      values.map(normalizePartNumber).filter(function (value) { return value.length > 0; })
    );
    if (!exactMatches.size) {
      host.hidden = true;
      return;
    }

    host.dataset.i40Ready = 'true';
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }
      var isMatch = exactMatches.has(normalizePartNumber(input.value));
      result.classList.toggle('is-match', isMatch);
      result.classList.toggle('is-no-match', !isMatch);
      result.textContent = isMatch ? MATCH_MESSAGE : NO_MATCH_MESSAGE;
    });
  }

  function syncTabs(panel) {
    var controls = Array.prototype.slice.call(panel.querySelectorAll('.js-tab-controls > li[data-target]'));
    controls.forEach(function (control, index) {
      var targetSelector = control.getAttribute('data-target');
      var target = targetSelector ? panel.querySelector(targetSelector) : null;
      if (!control.id) control.id = 'i40-tab-' + index + '-' + Math.random().toString(36).slice(2, 8);
      control.setAttribute('role', 'tab');
      control.setAttribute('aria-selected', control.classList.contains('active') ? 'true' : 'false');
      control.setAttribute('tabindex', control.classList.contains('active') ? '0' : '-1');
      if (target) {
        control.setAttribute('aria-controls', target.id);
        target.setAttribute('role', 'tabpanel');
        target.setAttribute('aria-labelledby', control.id);
        target.setAttribute('aria-hidden', target.classList.contains('active') ? 'false' : 'true');
      }
    });
  }

  function setupTabs(panel) {
    var list = panel.querySelector('.js-tab-controls');
    if (!list) return;
    list.setAttribute('role', 'tablist');
    syncTabs(panel);

    if (panel.dataset.i40TabsReady === 'true') return;
    panel.dataset.i40TabsReady = 'true';

    list.addEventListener('click', function () {
      window.setTimeout(function () { syncTabs(panel); }, 0);
    });

    list.addEventListener('keydown', function (event) {
      var current = event.target.closest('li[data-target]');
      if (!current) return;
      var controls = Array.prototype.slice.call(list.querySelectorAll(':scope > li[data-target]'));
      var index = controls.indexOf(current);
      var next = null;

      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        current.click();
        return;
      }
      if (event.key === 'ArrowRight') next = controls[(index + 1) % controls.length];
      if (event.key === 'ArrowLeft') next = controls[(index - 1 + controls.length) % controls.length];
      if (event.key === 'Home') next = controls[0];
      if (event.key === 'End') next = controls[controls.length - 1];
      if (next) {
        event.preventDefault();
        next.focus();
        next.click();
      }
    });

    new MutationObserver(function () { syncTabs(panel); })
      .observe(list, { childList: true, subtree: true });
  }

  function showFitmentSuccess() {
    var params;
    try {
      params = new URLSearchParams(window.location.search);
    } catch (error) {
      return;
    }
    if (params.get('i40') !== 'ok') return;
    document.querySelectorAll('[data-i40-form-success]').forEach(function (message) {
      message.hidden = false;
    });
  }

  function setupFitmentLinks() {
    document.querySelectorAll('.js-i40-goto-fitment').forEach(function (link) {
      link.addEventListener('click', function (event) {
        var target = document.getElementById('i40-fitment-help');
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        var focusTarget = target.querySelector('input, textarea, button');
        if (focusTarget) window.setTimeout(function () { focusTarget.focus(); }, 350);
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-i40-verifier]').forEach(setupVerifier);
    document.querySelectorAll('.i40-product-details .js-tab-panel').forEach(setupTabs);
    showFitmentSuccess();
    setupFitmentLinks();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
